import ClientSummaryReport from './CaseSummaryReport';

export default ClientSummaryReport;
